import type { EvaluationContext } from '@openfeature/web-sdk';

import type { AccountState } from '../../../reducers/account.reducer';

export type CurrentAppContext = {
  AppId?: string;
  OrgId?: string;
};

const ANONYMOUS_TARGETING_KEY = 'anonymous';

export function buildFeatureFlagEvaluationContext(
  account: AccountState,
  currentApp: CurrentAppContext,
  isFlipdishStaff: boolean
): EvaluationContext {
  const userId = String(account.AccountId ?? ANONYMOUS_TARGETING_KEY);

  return {
    targetingKey: userId,
    userId,
    brandId: currentApp.AppId ?? '',
    isFlipdishStaff,
    orgId: currentApp.OrgId ?? '',
  };
}
